import React from "react";
import { getWalletFlatWithdrawComponent } from "@/pages/wallet/strategy/walletStrategy";

const FlatWidthdraw = () => {
  const Component = getWalletFlatWithdrawComponent();
  return <Component />;
};

export default FlatWidthdraw;
